module.exports = __webpack_public_path__ + "static/img/apdefault.05f527c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apdefault.jpg
// module id = XUWT
// module chunks = 2